import { useTranslation } from "react-i18next";
import { Webhook, Clock, Mail, MessageCircle } from "lucide-react";

const TRIGGER_ICONS = {
    WEBHOOK: Webhook,
    TIME: Clock,
    EMAIL: Mail,
    WHATSAPP: MessageCircle,
};

export default function TriggersTab({ data }) {
    const { t } = useTranslation();
    const triggers = data?.workflow?.triggers || [];

    if (triggers.length === 0) {
        return <p className="text-muted-foreground text-sm p-4">{t("admin.automationPlayground.noTriggers")}</p>;
    }

    return (
        <div className="space-y-3 mt-3">
            {triggers.map((trigger) => {
                const Icon = TRIGGER_ICONS[trigger.type] || Webhook;
                return (
                    <div key={trigger.id} className="border rounded-lg p-4 bg-white">
                        <div className="flex items-center gap-2 mb-2">
                            <Icon className="h-4 w-4 text-slate-600" />
                            <span className="font-medium text-sm">{trigger.type}</span>
                            <span className="text-xs font-mono text-slate-400">{trigger.id}</span>
                        </div>
                        {trigger.publicKey && (
                            <p className="text-xs font-mono text-slate-500 mb-2">
                                publicKey: {trigger.publicKey}
                            </p>
                        )}
                        {Object.keys(trigger.config || {}).length > 0 && (
                            <div className="bg-slate-50 rounded p-2 mb-2">
                                <p className="text-xs font-medium text-slate-500 mb-1">
                                    {t("admin.automationPlayground.config")}
                                </p>
                                <pre className="text-xs font-mono whitespace-pre-wrap">
                                    {JSON.stringify(trigger.config, null, 2)}
                                </pre>
                            </div>
                        )}
                        {trigger.schedule && (
                            <div className="bg-blue-50 rounded p-2">
                                <p className="text-xs font-medium text-blue-600 mb-1">
                                    {t("admin.automationPlayground.schedule")}
                                </p>
                                <pre className="text-xs font-mono whitespace-pre-wrap">
                                    {JSON.stringify(trigger.schedule, null, 2)}
                                </pre>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
